/* ── Shared mock panel wrapper ── */
const Panel = ({ children }) => (
  <div className="flex h-full flex-col gap-3.5 p-7 sm:p-9 lg:p-12">
    {children}
  </div>
);

export default Panel;
